import SpaceBetween from "@awsui/components-react/space-between";
import React, {useState} from "react";
import NavigationBar from "components/NavigationBar";
import Container from "@awsui/components-react/container";
import Header from "@awsui/components-react/header";
import {FlashbarProps} from "@awsui/components-react/flashbar/interfaces";
import Box from "@awsui/components-react/box";
import Link from "@awsui/components-react/link";
import League from "model/League";
import LeaguesSelect from "components/LeaguesSelect";
import UsersSelect from "components/UsersSelect";
import User from "model/User";
import RemovePenaltyButton from "pages/admin/pages/remove_penalty/components/RemovePenaltyButton";
import SubmitFlashbar from "components/SubmitFlashbar";
import CompetitionsSelect from "components/CompetitionsSelect";
import Competition from "model/Competition";


const RemovePenaltyPage: React.FC = () => {

    const [selectedCompetition, setSelectedCompetition] = useState<Competition>();
    const [selectedLeague, setSelectedLeague] = useState<League>();
    const [selectedUser, setSelectedUser] = useState<User>();
    const [submitMessage, setSubmitMessage] = useState<FlashbarProps.MessageDefinition>();


    return (
        <SpaceBetween size="l">
            <NavigationBar/>
            <Container
                header={
                    <Box variant={"span"}>
                        <Header variant="h1">Remove penalty</Header>
                        <Link variant={"info"} href={"/admin"}>Back</Link>
                    </Box>
                }
            >
                <SpaceBetween size={"m"}>
                    {submitMessage && (
                        <SubmitFlashbar
                            submitMessage={submitMessage}
                            setSubmitMessage={setSubmitMessage}
                        />
                    )}
                    <LeaguesSelect
                        selectedLeague={selectedLeague}
                        setSelectedLeague={setSelectedLeague}
                    />
                    {selectedLeague && (
                        <UsersSelect
                            selectedUser={selectedUser}
                            setSelectedUser={setSelectedUser}
                            leagueId={selectedLeague?.leagueId}
                        />
                    )}
                    {selectedLeague && selectedUser && (
                        <CompetitionsSelect
                            selectedCompetition={selectedCompetition}
                            setSelectedCompetition={setSelectedCompetition}
                            disabledStates={[]}
                        />
                    )}
                    {selectedLeague && selectedUser && selectedCompetition?.code && (
                        <RemovePenaltyButton
                            userToPenalty={selectedUser}
                            setSubmitMessage={setSubmitMessage}
                            competitionCode={selectedCompetition.code}
                            leagueId={selectedLeague?.leagueId}
                        />
                    )}
                </SpaceBetween>
            </Container>
        </SpaceBetween>
    )
};

export default RemovePenaltyPage;